import { catalog, selectedChannel } from './admin-globals.js';
import { authHeaders } from './admin-auth.js';
import { escHtml, showToast } from './admin-ui-base.js';
import { canEditChannel } from './catalog-ui.js';
import { loadCatalog } from './catalog-api.js';

let _searchTimer = null;
let _libraryItems = [];

export function openLibraryModal() {
  const ch = catalog[selectedChannel];
  if (!ch) {
    showToast('SELECCIONA UN CANAL', true);
    return;
  }
  if (!canEditChannel(ch)) {
    showToast('CANAL EN SOLO LECTURA', true);
    return;
  }
  document.getElementById('library-search-input').value = '';
  document.getElementById('library-modal').classList.remove('hidden');
  document.getElementById('library-search-input').focus();
  void searchLibrary('');
}

export function closeLibraryModal() {
  document.getElementById('library-modal').classList.add('hidden');
}

export function onLibrarySearchInput(value) {
  clearTimeout(_searchTimer);
  _searchTimer = setTimeout(() => void searchLibrary(value), 280);
}

export async function searchLibrary(query) {
  const resultsEl = document.getElementById('library-search-results');
  resultsEl.innerHTML = '<div class="search-empty">CARGANDO…</div>';

  try {
    const params = new URLSearchParams({ limit: '60', offset: '0' });
    const q = (query ?? document.getElementById('library-search-input').value).trim();
    if (q) params.set('q', q);

    const res = await fetch(`/api/youtube/library?${params}`, { headers: authHeaders() });
    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      resultsEl.innerHTML = '<div class="search-empty">ERROR AL CARGAR</div>';
      showToast(typeof data.detail === 'string' ? data.detail : 'ERROR BIBLIOTECA', true);
      return;
    }

    const items = data.items || [];
    _libraryItems = items;
    if (!items.length) {
      resultsEl.innerHTML = '<div class="search-empty">BIBLIOTECA VACÍA — IMPORTA PLAYLIST O GUARDA VÍDEOS YT</div>';
      return;
    }

    const ch = catalog[selectedChannel];
    const inChannel = new Set(
      (ch?.videos || [])
        .filter((v) => v.type === 'youtube' && v.id)
        .map((v) => v.id)
    );

    resultsEl.innerHTML = items
      .map((item, i) => {
        const dur = item.duration > 0 ? `${Math.floor(item.duration / 60)}:${String(item.duration % 60).padStart(2, '0')}` : '—';
        const thumb = item.thumbnail_url || `https://i.ytimg.com/vi/${item.yt_id}/mqdefault.jpg`;
        const inCh = inChannel.has(item.yt_id);
        return `
        <div class="search-item">
          <img src="${escHtml(thumb)}" class="search-item-thumb" alt="">
          <div class="search-item-info">
            <div class="search-item-title">${escHtml(item.title || item.yt_id)}</div>
            <div class="search-item-channel">${escHtml(item.channel_title || item.yt_id)} · ${dur}</div>
          </div>
          <div class="search-item-actions">
            <button class="btn btn-secondary" onclick="window.previewFromLibraryIndex(${i})">▶</button>
            <button class="btn btn-primary" ${inCh ? 'disabled title="Ya en el canal"' : ''} onclick="window.addFromLibrary('${item.yt_id}')">${inCh ? '✓' : '+'}</button>
          </div>
        </div>`;
      })
      .join('');
  } catch (e) {
    resultsEl.innerHTML = '<div class="search-empty">ERROR DE CONEXIÓN</div>';
    console.error(e);
  }
}

export async function addFromLibrary(ytId) {
  const ch = catalog[selectedChannel];
  if (!ch?.id || !canEditChannel(ch)) return;

  try {
    const res = await fetch('/api/youtube/library/add-to-channel', {
      method: 'POST',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ channel_id: ch.id, yt_ids: [ytId] }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      showToast(typeof data.detail === 'string' ? data.detail : 'ERROR', true);
      return;
    }
    if (data.added < 1) {
      showToast('YA ESTABA EN EL CANAL O NO EXISTE EN BIBLIOTECA', true);
      return;
    }
    await loadCatalog({ channelId: ch.id });
    showToast('AÑADIDO DESDE BIBLIOTECA');
    void searchLibrary();
  } catch (e) {
    showToast('ERROR DE CONEXIÓN', true);
    console.error(e);
  }
}

export function previewFromLibraryIndex(index) {
  const item = _libraryItems[index];
  if (!item || !window.openSingleVideoPreview) return;
  window.openSingleVideoPreview({
    type: 'youtube',
    id: item.yt_id,
    title: item.title || item.yt_id,
  });
}

async function upsertToLibrary(payload) {
  try {
    await fetch('/api/youtube/library/upsert', {
      method: 'POST',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  } catch (e) {
    console.warn('[library] upsert failed', e);
  }
}

export function upsertFromSearchItem(item) {
  const sn = item.snippet || {};
  const thumbs = sn.thumbnails || {};
  const thumb = (thumbs.medium || thumbs.default || {}).url || '';
  void upsertToLibrary({
    yt_id: item.id.videoId,
    title: sn.title || '',
    duration: 0,
    thumbnail_url: thumb,
    channel_title: sn.channelTitle || '',
  });
}
